import React from 'react';
import { HouseIcon, RocketIcon, VideoIcon, WrenchIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { benefits } from '../data/content';
const ICONS = {
  camera: VideoIcon,
  wrench: WrenchIcon,
  home: HouseIcon,
  rocket: RocketIcon
};
export function BenefitsSection() {
  return <section aria-labelledby="beneficios" className="bg-white" data-id="element-16" data-mp="3nohvc9ve1qvt">
      <div className="mx-auto max-w-letter px-4 py-7 text-center sm:px-6 sm:py-8" data-id="element-17" data-mp="38s0krkv0wgab">
        <h2 id="beneficios" className="font-display text-xl uppercase leading-[1.1] tracking-tight text-brand-dark sm:text-3xl" data-id="element-18" data-mp="38u4w2nv94hkm">
          ¿Qué puede cambiar cuando empezás?
        </h2>
        <p className="mx-auto mt-1.5 max-w-xl text-sm font-semibold leading-snug text-ink-muted" data-id="element-19" data-mp="34qfe4h930y8k">
          Una habilidad técnica puede abrir nuevas posibilidades.
        </p>

        <ul className="mt-4 grid gap-2.5 sm:grid-cols-2" data-id="element-20" data-mp="xxwexpxt2v0v">
          {benefits.map((benefit, i) => {
          const Icon = ICONS[benefit.icon];
          return <Reveal key={benefit.title} as="li" delay={i * 0.03} className="flex h-full gap-3 rounded-lg border border-line bg-mist p-3.5 text-left" data-id="element-21" data-mp="2bdutgwu9yodt" data-mpi={i}>
                <span className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-md bg-brand" data-id="element-22" data-mp="2l73dwixhzgb1">
                  <Icon size={18} className="text-white" aria-hidden="true" data-id="element-23" data-mp="1sgbihno9avor" />
                </span>
                <div data-id="element-24" data-mp="1oepy7h9e7f4j">
                  <h3 className="text-[0.82rem] font-extrabold uppercase leading-tight tracking-tight text-brand-dark" data-id="element-25" data-mp="1of81uyydwvmh">
                    {benefit.title}
                  </h3>
                  <p className="mt-1 text-[0.8rem] font-medium leading-snug text-ink-muted sm:text-sm" data-id="element-26" data-mp="1xfeekim9drkl">
                    {benefit.desc}
                  </p>
                </div>
              </Reveal>;
        })}
        </ul>
      </div>
    </section>;
}